import React from "react";

const WebSiteLink = React.forwardRef(function WebSiteLink(
  { locale, to, intlTo, children, ...props },
  ref
) {
  const path = intlTo?.[locale] ?? to;
  const url = `${process.env.REACT_APP_WEBSITE_BASE_URL}/${locale}${path}`;

  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      {...props}
      ref={ref}
    >
      {children}
    </a>
  );
});

WebSiteLink.defaultProps = {
  locale: "fr",
};

export default WebSiteLink;
